// ─── Utility ──────────────────────────────────────────────────────────────────

/**
 * Extracts the tab suffix from a pathname by stripping the given prefix.
 * Returns an empty string when the pathname does not start with the prefix.
 *
 * @example
 * extractTabSuffix('/settings/spaces/abc123/users', '/settings/spaces/abc123') // '/users'
 * extractTabSuffix('/settings', '/settings/spaces/abc123') // ''
 */
export function extractTabSuffix(pathname: string, prefix: string): string {
  return pathname.startsWith(prefix) ? pathname.slice(prefix.length) : '';
}
